import { render } from "./WithdrawalModal.vue?vue&type=template&id=0a78c70c&scoped=true"
import script from "./WithdrawalModal.vue?vue&type=script&lang=js"
export * from "./WithdrawalModal.vue?vue&type=script&lang=js"

import "./WithdrawalModal.vue?vue&type=style&index=0&id=0a78c70c&lang=scss&scoped=true"

import exportComponent from "G:\\Programming\\VueProjects\\radinrealp2p\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a78c70c"]])

export default __exports__